
<div class="gauge-container">
    <canvas #chartCanvas class="no-print"></canvas>
    <div class="prospect-label-container">
        <h3 id="gaugeValueLabel">{{needleValue}}</h3>
        <h4 id="gaugeTextLabel">Data Match Quality</h4>
    </div>
</div>
